export const CREATE_CASE_PAGE_ROUTES = {
  "accountPage": "/create-a-case/create-new-account",
  "echannelPage": "/create-a-case/create-new-echannel",
  "glsPage": "/create-a-case/create-new-glsproduct"
};


export const CASE_CONFLICT_STATUSES = {
  "no_conflicts": "No conflicts",
  "case_in_progress": "Case in progress",
  "Standard": "Standard",
  "New to GDocs": "New to GDocs",
  "Negotiated": "Negotiated"
};


export const ACCORDION_STATUSES = {
  "incomplete": "Incomplete",
  "complete": "Complete",
  "optional": "(Optional)"
};


export const ADD_GLS_PRODUCT_PAGE_CONSTANTS = {
  "interest": "Interest Enhancement",
  "cashcon": "Cash Concentration",
  "notionalPool": "Notional Pooling"
};


export const ECHANNEL_HSBCNET = "urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:hsbcNet";
export const ECHANNEL_HOST_TO_HOST = "urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:hostToHost";
export const ECHANNEL_HSBCAPI = "urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:API";

export const CASE_STATUS_CONSTANTS = {
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:documentationDraft": "Documentation, draft",
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:delete": "Delete",
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:cancelled": "Cancel",
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:signed": "Signed",
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:complete": "Complete",
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:incomplete": "Incomplete",
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:InitialRequestIncomplete": "Initial request incomplete",
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:InitialRequestDataReady": "Initial request, data ready",
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:documentationAwaitingSignature": "Documentation, awaiting signature",
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:awaitingActivation": "Awaiting activation"
}
export const INITAL_REQUEST_DATA_READY = "urn:hsbc:cmb:gdocs:cases:taxonomies:status:InitialRequestDataReady";
export const DOCUMENTATION_DRAFT = "urn:hsbc:cmb:gdocs:cases:taxonomies:status:documentationDraft";
export const AWAITING_SIGNATURE = "urn:hsbc:cmb:gdocs:cases:taxonomies:status:documentationAwaitingSignature";
export const CASE_COMPLETED = "urn:hsbc:cmb:gdocs:cases:taxonomies:status:complete";
export const CASE_CANCELLED = "urn:hsbc:cmb:gdocs:cases:taxonomies:status:cancelled";
export const INITIAL_REQUEST_INCOMPLETE = "urn:hsbc:cmb:gdocs:cases:taxonomies:status:InitialRequestIncomplete";

export const CASE_STATUS_LEVEL_LOOKUP_TABLE = {
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:InitialRequestIncomplete": 0,
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:InitialRequestDataReady": 1,
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:documentationDraft": 2,
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:documentationAwaitingSignature": 3,
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:awaitingActivation": 4,
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:complete": 5,
  "urn:hsbc:cmb:gdocs:cases:taxonomies:status:cancelled": 6
}

export const ROLES = {
  "ADMIN": "urn:hsbc:cmb:gdocs:user:taxonomies:user:admin",
  "CASE_WORKER": "urn:hsbc:cmb:gdocs:user:taxonomies:user:caseworker",
  "CUSTOMER": "urn:hsbc:cmb:gdocs:user:taxonomies:user:customer",
  'SALES_MANAGER': 'urn:hsbc:cmb:gdocs:user:taxonomies:user:salesManager'
}

export const ADMIN_ROLE = "urn:hsbc:cmb:gdocs:user:taxonomies:user:admin";
export const CASE_WORKER_ROLE = "urn:hsbc:cmb:gdocs:user:taxonomies:user:caseworker";


export const CASEBODY_TAB_NAMES = ["customerDetailsTab", "productRequestsTab", "documentationTab", "activationTab"];

export const SWEEP_TYPES = {
  ZERO_BALANCING_SWEEP: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:zeroBalancing",
  CREDIT_SWEEP: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:creditSweep",
  DEBIT_SWEEP: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:debitSweep",
  TARGET_BALANCING_SWEEP: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:targetBalancing",
  RANGE_BALANCING_SWEEP: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:rangeBalancing",
  RANGE_BASED_TARGET_BALANCING_SWEEP: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:rangeBasedTargetBalancing",
  PERCENTAGE_CREDIT_SWEEP: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:percentageCreditSweep",
  PERCENTAGE_DEBIT_SWEEP: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:percentageDebitSweep",
  FIXED_AMOUNT_SWEEP: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:fixedAmountSweep",
  DRAIN_POOL_SWEEP: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:drainThePool",
  DYNAMIC_SWEEP_STANDARD: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepStandard",
  DYNAMIC_SWEEP_ENHANCED: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepEnhanced",
  DYNAMIC_SWEEP_ENHANCED_ZBA: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepEnhancedZBA"
}

export const GLS_ACTIVATIONS_STATUSES = {
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:dataIncomplete': 'Data Incomplete',
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:dataComplete': 'Data Complete',
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:awaitingCIapproval': 'Awaiting CI approval',
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:cIapproved': 'CI Approved',
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:cIrejected': 'CI Rejected',
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:awaitingCustomerApproval': 'Awaiting customer approval',
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:customerApproved': 'Customer Approved',
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:customerRejected': 'Customer Rejected'
}

export const UNCLICKABLE_GLS_ACTIVATIONS_STATUSES = [
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:awaitingCIapproval',
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:cIapproved',
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:awaitingCustomerApproval',
  'urn:hsbc:cmb:gdocs:gls:taxonomies:status:customerApproved',
  'urn:hsbc:cmb:gdocs:products:taxonomies:status:active'
]

export const COUNTRY_TAXANOMY = [
  "urn:hsbc:cmb:gdocs:products:taxonomies:countries:China:EN",
  "urn:hsbc:cmb:gdocs:products:taxonomies:countries:Korea,democraticpeople'srepublicof:EN",
  "urn:hsbc:cmb:gdocs:products:taxonomies:countries:Japan:EN",
  "urn:hsbc:cmb:gdocs:products:taxonomies:countries:Korea:EN",
  "urn:hsbc:cmb:gdocs:products:taxonomies:countries:Taiwan:EN",
  "urn:hsbc:cmb:gdocs:products:taxonomies:countries:Vietnam:EN"
]

export const FORM_FIELDS_INITIAL_RULE_LOOKUP_TABLE = {
  'sweep-other-sweep-instructions': {
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:zeroBalancing': {
      visibleFields: [],
      hiddenFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:creditSweep': {
      visibleFields: ['pegBalance', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop'],
      hiddenFields: ['minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:debitSweep': {
      visibleFields: ['minimumBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'debitSweepTopUp'],
      hiddenFields: ['pegBalance', 'targetBalance', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:targetBalancing': {
      visibleFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT'],
      hiddenFields: ['minSweepAmountIN', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:rangeBalancing': {
      visibleFields: ['pegBalance', 'minimumBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp'],
      hiddenFields: ['targetBalance']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:rangeBasedTargetBalancing': {
      visibleFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT'],
      hiddenFields: ['creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:percentageCreditSweep': {
      visibleFields: ['pegBalance', 'minSweepAmountOUT', 'maxSweepAmountOUT'],
      hiddenFields: ['minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:percentageDebitSweep': {
      visibleFields: ['minimumBalance', 'minSweepAmountIN', 'maxSweepAmountIN'],
      hiddenFields: ['pegBalance', 'targetBalance', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:fixedAmountSweep': {
      visibleFields: [],
      hiddenFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:drainThePool': {
      visibleFields: ['pegBalance', 'minimumBalance'],
      hiddenFields: ['targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepStandard': {
      visibleFields: [],
      hiddenFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepEnhanced': {
      visibleFields: [],
      hiddenFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepEnhancedZBA': {
      visibleFields: [],
      hiddenFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    }
  },
  'sweep-other-sweep-options': {
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:zeroBalancing': {
      visibleFields: ['csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:creditSweep': {
      visibleFields: ['csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:debitSweep': {
      visibleFields: ['csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:targetBalancing': {
      visibleFields: ['csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:rangeBalancing': {
      visibleFields: ['csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:rangeBasedTargetBalancing': {
      visibleFields: ['csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:percentageCreditSweep': {
      visibleFields: ['percentage', 'percentageGroupSweepRule', 'csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['fixedAmount', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:percentageDebitSweep': {
      visibleFields: ['percentage', 'percentageGroupSweepRule', 'csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['fixedAmount', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:fixedAmountSweep': {
      visibleFields: ['fixedAmount', 'csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['percentage', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:drainThePool': {
      visibleFields: ['csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepStandard': {
      visibleFields: ['dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule', 'csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepEnhanced': {
      visibleFields: ['dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule', 'csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepEnhancedZBA': {
      visibleFields: ['dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule', 'csrMasterAcount', 'csrSubAccount', 'creditFirstGroupSweepRule', 'weightedAverageGroupSweepRule', 'reverseSweepHolidaySkip', 'holidayAdjustmentOption'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule']
    }
  }
};
export const ACCOUNT_REGION_CROSS_BORDER = 'crossBorder';
export const DAILY = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:daily';
export const NOT_APPLICABLE = 'N/A';
export const DATA_INCOMPLETE = 'urn:hsbc:cmb:gdocs:gls:taxonomies:status:dataIncomplete';
export const DATA_COMPLETE = 'urn:hsbc:cmb:gdocs:gls:taxonomies:status:dataComplete';
export const READY_FOR_CI_APPROVAL = 'urn:hsbc:cmb:gdocs:gls:taxonomies:status:awaitingCIapproval';
export const CI_APPROVED = 'urn:hsbc:cmb:gdocs:gls:taxonomies:status:cIapproved';
export const CI_REJECTED = 'urn:hsbc:cmb:gdocs:gls:taxonomies:status:cIrejected';
export const READY_FOR_CUSTOMER_REVIEW = 'urn:hsbc:cmb:gdocs:gls:taxonomies:status:awaitingCustomerApproval';
export const CUSTOMER_APPROVED = 'urn:hsbc:cmb:gdocs:products:taxonomies:status:active';
//export const CUSTOMER_APPROVED = 'urn:hsbc:cmb:gdocs:gls:taxonomies:status:customerApproved';
export const CUSTOMER_REJECTED = 'urn:hsbc:cmb:gdocs:gls:taxonomies:status:customerRejected';
export const AWAITING_ACTIVATION = 'urn:hsbc:cmb:gdocs:cases:taxonomies:status:awaitingActivation';
export const ACH_UK = 'United Kingdom';

export const FORM_REFS = {
  "/content/dam/formsanddocuments/gdocs/fragments/general/staff-login": "/aemData/formData/json_staff-login-form",
  "/content/dam/formsanddocuments/gdocs/fragments/general/password-form": "/aemData/formData/json_password-form",
  "/content/dam/formsanddocuments/gdocs/forms/entity/create-case-add-entity": "/aemData/formData/json_create-entity-basic-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/entity/create-entity-basic-details": "/aemData/formData/json_create-entity-basic-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/account/create-account-basic-details": "/aemData/formData/json_create-account-basic-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/e-channel/create-e-channel-basic-details": "/aemData/formData/json_create-e-channel-basic-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/create-case-add-gls": "/aemData/formData/json_create-case-add-gls-form",
  "/content/dam/formsanddocuments/gdocs/fragments/ach-credit/add-ach-credit-form": "/aemData/formData/json_add-ach-credit-form",
  "/content/dam/formsanddocuments/gdocs/fragments/corporate-card/add-corporate-card-form": "/aemData/formData/json_add-corporate-card-form",

  "/content/dam/formsanddocuments/gdocs/fragments/general/create-addresses": "/aemData/formData/json_create-addresses-form",
  "/content/dam/formsanddocuments/gdocs/fragments/general/create-contacts": "/aemData/formData/json_create-contacts-form",
  "/content/dam/formsanddocuments/gdocs/fragments/general/create-declaration-signatory": "/aemData/formData/json_create-declaration-signatory-form",

  "/content/dam/formsanddocuments/gdocs/fragments/general/create-authorised-persons": "/aemData/formData/json_create-authorised-persons-form",
  "/content/dam/formsanddocuments/gdocs/fragments/e-channel/edit-e-channel-reporting": "/aemData/formData/json_edit-e-channel-reporting-form",

  "/content/dam/formsanddocuments/gdocs/forms/e-channel/case-details-add-echannel": "/aemData/formData/json_create-e-channel-basic-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/account/account-basic-details": "/aemData/formData/json_create-account-basic-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/account/account-address-and-contacts": "/aemData/formData/json_account-address-and-contacts",
  "/content/dam/formsanddocuments/gdocs/fragments/account/account-paper-statement": "/aemData/formData/json_account-paper-statement-form",
  "/content/dam/formsanddocuments/gdocs/fragments/account/account-signatories": "/aemData/formData/json_account-signatories-form",
  "/content/dam/formsanddocuments/gdocs/forms/e-channel/echannel-reporting": "/aemData/formData/json_account-echannel-reporting",

  "/content/dam/formsanddocuments/gdocs/fragments/e-channel/e-channel-basic-details": "/aemData/formData/json_create-e-channel-basic-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/e-channel/e-channel-access-control": "/aemData/formData/json_e-channel-access-control-form",
  "/content/dam/formsanddocuments/gdocs/fragments/e-channel/e-channel-contacts": "/aemData/formData/json_e-channel-contacts-form",
  "/content/dam/formsanddocuments/gdocs/fragments/e-channel/e-channel-product-enablement": "/aemData/formData/json_e-channel-product-enablement-form",
  "/content/dam/formsanddocuments/gdocs/fragments/account/create-existing-account-new-echannel": "/aemData/formData/json_create-existing-account-new-echannel-form",
  "/content/dam/formsanddocuments/gdocs/fragments/account/create-existing-account-existing-echannel": "/aemData/formData/json_create-existing-account-existing-echannel-form",
  "/content/dam/formsanddocuments/gdocs/fragments/account/create-newReportAccount-form": "/aemData/formData/json_create-newReportAccount-form",

  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-basic-details": "/aemData/formData/json_create-case-add-gls-form",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-sweep-instructions": "/aemData/formData/json_sweep-instructions-accordian-page",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-account-interest-limits": "/aemData/formData/json_gls-account-interest-limits-form",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-sweep-group-limits": "/aemData/formData/json_gls-sweep-group-limits",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-order-sweep-execution": "/aemData/formData/json_gls-order-sweep-execution",

  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-country-and-accounts": "/aemData/formData/json_gls-country-and-accounts",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-tiers-and-settings": "/aemData/formData/json_gls-tiers-and-settings",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-detailed-settings": "/aemData/formData/json_gls-detailed-settings",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/add-gls-other-account-ie": "/aemData/formData/json_create-gls-sub-form-ie",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/edit-gls-other-account-ie": "/aemData/formData/json_edit-gls-sub-form-ie ",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/add-gls-other-account-cc": "/aemData/formData/json_create-gls-sub-form-cc",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/edit-gls-other-account-cc": "/aemData/formData/json_edit-gls-sub-form-cc",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/add-gls-other-account-np": "/aemData/formData/json_create-gls-sub-form-np",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/edit-gls-other-account-np": "/aemData/formData/json_edit-gls-sub-form-np",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-pooling-structure": "/aemData/formData/json_gls-pooling-structure",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-other-settings": "/aemData/formData/json_gls-other-settings",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-interest-optimisation": "/aemData/formData/json_notional-pooling-interest-optimisation-settings-form",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/add-gls-other-account-notional-pooling": "/aemData/formData/json_add-gls-other-account-notional-pooling",

  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-sweep-participants-accounts-form": "/aemData/formData/json_gls-sweep-participants-accounts-form",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-sweep-instruction-form": "/aemData/formData/json_gls-sweep-instruction-form",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-other-sweep-instructions-form": "/aemData/formData/json_gls-other-sweep-instructions-form",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-other-sweep-options-form": "/aemData/formData/json_gls-other-sweep-options-form",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-ccr-interest-form": "/aemData/formData/json_gls-ccr-interest-form",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/gls-ccr-bilateral-limits-form": "/aemData/formData/json_gls-ccr-bilateral-limits-form",
  "/content/dam/formsanddocuments/gdocs/fragments/gls/new_detailed-settings": "/aemData/formData/json_new-detailed-settings",

  "/content/dam/formsanddocuments/gdocs/forms/country-forms/india-declaration-letter": "/aemData/formData/json_india-declaration-letter",
  "/content/dam/formsanddocuments/gdocs/forms/country-forms/czech-republic-personal-data-consent": "aemData/formData/json_czech-republic-personal-data-consent",
  "/content/dam/formsanddocuments/gdocs/forms/country-forms/canada-quebec": "/aemData/formData/json_canada-quebec",
  "/content/dam/formsanddocuments/gdocs/forms/country-forms/canada-personal-information-consent": "/aemData/formData/json_canada-personal-information-consent",
  "/content/dam/formsanddocuments/gdocs/forms/country-forms/spain-declaration-of-tax-residence": "/aemData/formData/json_spain-declaration-of-tax-residence",
  "/content/dam/formsanddocuments/gdocs/forms/country-forms/poland-hsbc-net-user-notification": "/aemData/formData/json_poland-hsbc-net-user-notification",
  "/content/dam/formsanddocuments/gdocs/forms/country-forms/australia-authorised-referee": "/aemData/formData/json_australia-authorised-referee",
  "/content/dam/formsanddocuments/gdocs/fragments/country-forms/italy-account-signatory-form2": "/aemData/formData/json_italy-account-signatory-form2",
  "/content/dam/formsanddocuments/gdocs/fragments/country-forms/france-law-murcef": "/aemData/formData/json_france-law-murcef-form",

  "/content/dam/formsanddocuments/gdocs/fragments/modal/invite-collaborators": "/aemData/formData/json_invite-collaborators-form",
  "/content/dam/formsanddocuments/gdocs/fragments/modal/mark-as-signed": "/aemData/formData/json_mark-as-signed-form",
  "/content/dam/formsanddocuments/gdocs/fragments/modal/mark-as-activated": "/aemData/formData/json_add-mark-as-activated-form",
  "/content/dam/formsanddocuments/gdocs/fragments/modal/mark-as-activated-echannel": "/aemData/formData/json_add-mark-as-activated-echannel-form",

  "/content/dam/formsanddocuments/gdocs/fragments/ach-credit/ach-credit-basic-details": "/aemData/formData/json_ach-credit-basic-details",
  "/content/dam/formsanddocuments/gdocs/fragments/ach-credit/ach-credit-address-and-contacts-form": "/aemData/formData/json_ach-credit-address-and-contacts-form",
  "/content/dam/formsanddocuments/gdocs/fragments/ach-credit/create-other-ach-credit-account-form": "/aemData/formData/json_create-other-ach-credit-account-form",
  "/content/dam/formsanddocuments/gdocs/fragments/ach-credit/ach-credit-transfer-reports-form": "/aemData/formData/json_ach-credit-transfer-reports-form",
  "/content/dam/formsanddocuments/gdocs/fragments/ach-credit/create-ach-credit-address-form": "/aemData/formData/json_create-ach-credit-address-form",
  "/content/dam/formsanddocuments/gdocs/fragments/ach-credit/create-ach-credit-contact-form": "/aemData/formData/json_create-ach-credit-contact-form",
  "/content/dam/formsanddocuments/gdocs/fragments/ach-credit/create-ach-echannel-form": "/aemData/formData/json_create-ach-echannel-form",
  "/content/dam/formsanddocuments/gdocs/fragments/ach-credit/ach-credit-transfer-specific-details-form": "/aemData/formData/json_ach-credit-transfer-specific-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/ach-credit/ach-credit-primary-and-additional-contact-details-form": "/aemData/formData/json_ach-credit-primary-and-additional-contact-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/ach-credit/ach-credit-mandatory-service-user-training-form": "/aemData/formData/json_ach-credit-mandatory-service-user-training-form",
  "/content/dam/formsanddocuments/gdocs/fragments/modal/mark-as-activated-achCredits": "/aemData/formData/json_add-mark-as-activated-achCredits-form",
  "/content/dam/formsanddocuments/gdocs/fragments/corporate-card/corporate-card-specific-details": "/aemData/formData/json_corporate-card-specific-details",
  "/content/dam/formsanddocuments/gdocs/fragments/corporate-card/corporate-card-address-and-contacts-form": "/aemData/formData/json_corporate-card-address-and-contacts-form",
  "/content/dam/formsanddocuments/gdocs/fragments/corporate-card/create-corporate-card-address-form": "/aemData/formData/json_create-corporate-card-address-form",
  "/content/dam/formsanddocuments/gdocs/fragments/corporate-card/create-corporate-card-contact-form": "/aemData/formData/json_create-corporate-card-contact-form",
  "/content/dam/formsanddocuments/gdocs/fragments/modal/mark-as-activated-corporateCards": "/aemData/formData/json_add-mark-as-activated-corporateCards-form",
  "/content/dam/formsanddocuments/gdocs/fragments/manual-case/manual-case-basic-detail-form": "/aemData/formData/json_manual-case-basic-detail-form",
  "/content/dam/formsanddocuments/gdocs/fragments/manual-case/manual-case-product-requests-form": "/aemData/formData/json_manual-case-product-requests-form",
  "/content/dam/formsanddocuments/gdocs/fragments/manual-case/manual-case-documentation-form": "/aemData/formData/json_manual-case-documentation-form",
  "/content/dam/formsanddocuments/gdocs/fragments/cash-flow-forecasting/add-cash-flow-forecasting-form": "/aemData/formData/json_add-cash-flow-forecasting-form",
  "/content/dam/formsanddocuments/gdocs/fragments/cash-flow-forecasting/cash-flow-forecasting-basic-details-form": "/aemData/formData/json_cash-flow-forecasting-basic-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/cash-flow-forecasting/cff-echannel-reporting-accordian-page": "/aemData/formData/json_cff-echannel-reporting-accordian-page",
  "/content/dam/formsanddocuments/gdocs/fragments/e-channel/edit-e-channel-reporting-form-cff": "/aemData/formData/json_edit-e-channel-reporting-form-cff",
  "/content/dam/formsanddocuments/gdocs/fragments/modal/mark-as-activated-cashFlowForecasting": "/aemData/formData/json_add-mark-as-activated-cashFlowForecasting-form",
  "/content/dam/formsanddocuments/gdocs/fragments/entity/create-sow-entity-basic-details-form": "/aemData/formData/json_create-sow-entity-basic-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/entity/edit-sow-entity-basic-details-form": "/aemData/formData/json_edit-sow-entity-basic-details-form",
  "/content/dam/formsanddocuments/gdocs/fragments/sow/sow-gls-sweep-participants-accounts-form": "/aemData/formData/json_sow-gls-sweep-participants-accounts-form",
  "/content/dam/formsanddocuments/gdocs/fragments/sow/sow-gls-sweep-instruction-form": "/aemData/formData/json_sow-gls-sweep-instruction-form",
  "/content/dam/formsanddocuments/gdocs/fragments/sow/sow-gls-other-sweep-instructions-form": "/aemData/formData/json_sow-gls-other-sweep-instructions-form",
  "/content/dam/formsanddocuments/gdocs/fragments/sow/sow-gls-account-interest-limits-form": "/aemData/formData/json_sow-gls-account-interest-limits-form",
  "/content/dam/formsanddocuments/gdocs/fragments/sow/sow-gls-icl-form": "/aemData/formData/json_sow-gls-icl-form",
  "/content/dam/formsanddocuments/gdocs/fragments/sow/sow-gls-icl-bilateral-limits-form": "/aemData/formData/json_sow-gls-icl-bilateral-limits-form",
  "/content/dam/formsanddocuments/gdocs/fragments/sow/sow-interest-optimisation": "/aemData/formData/json_sow-notional-pooling-interest-optimisation-settings-form",
  "/content/dam/formsanddocuments/gdocs/fragments/sow/sow-other-settings": "/aemData/formData/json_sow-other-settings",
  "/content/dam/formsanddocuments/gdocs/fragments/e-channel/convert-e-channel-basic-details": "/aemData/formData/json_convert-e-channel-basic-details-form"
};

export const sowCaseStatus = {
  inProgress: {
    "name": "urn:hsbc:cmb:gdocs:sows:taxonomies:status:InProgress",
    "value": "In Progress"
  },
  sharedWithCustomer: {
    "name": "urn:hsbc:cmb:gdocs:sows:taxonomies:status:SharedWithCustomer",
    "value": "Shared with Customer"
  },
  acknowledgedByCustomer: {
    "name": "urn:hsbc:cmb:gdocs:sows:taxonomies:status:AcknowledgedByCustomer",
    "value": "Acknowledged by Customer"
  },
  sentToImplementationManager: {
    "name": "urn:hsbc:cmb:gdocs:sows:taxonomies:status:SentoImplementationManager",
    "value": "Sent to Implementation Manager"
  },
  cancelled: {
    "name": "urn:hsbc:cmb:gdocs:sows:taxonomies:status:Cancelled",
    "value": "Cancelled"
  },
  allOpenSows: {
    "name": "urn:hsbc:cmb:gdocs:sows:taxonomies:status:allOpenSows",
    "value": "All Open SOWs"
  }
}

/* CMP Constants */
export const HSBC_UK = 'United Kingdom - HSBC UK';

export const HSBC_UK_PLC = 'United Kingdom - HSBC Bank plc';

export const achPaymentTypeMap = {
  'United Kingdom - HSBC UK': {
    'New Direct': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:newDirect:EN',
    'New Indirect': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:newInDirect:EN',
    'Transfer Of Sponsorship Direct': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:transferOfSponsorshipDirect:EN',
    'Transfer Of Sponsorship Indirect': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:transferOfSponsorshipIndirect:EN',
    'New Direct Corporate Access': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:newDca:EN',
    'Transfer Of Sponsorship Direct Corporate Access': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:transferOfSponsorshipDca:EN'
  },
  'United Kingdom - HSBC Bank plc': {
    'New Direct': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:newDirect:EN',
    'New Indirect': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:newInDirect:EN',
    'Transfer Of Sponsorship Direct': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:transferOfSponsorshipDirect:EN',
    'Transfer Of Sponsorship Indirect': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:transferOfSponsorshipIndirect:EN',
    'New Direct Corporate Access': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:newDca:EN',
    'Transfer Of Sponsorship Direct Corporate Access': 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:transferOfSponsorshipDca:EN'
  }
}

export const DOCUMENTATION_PATH_TYPES = {
  TBT: {
    code: 'TBT',
    label: 'TBT',
    description: 'Transaction Banking Terms'
  },
  GDOCS: {
    code: 'GDOCS',
    label: 'GDocs',
    description: 'Global Documentation Manager Terms'
  }
};

export const RESIDENT_ONLY_ACCOUNT_COUNTRIES = new Set([
  'urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedArabEmirates:EN',
  'urn:hsbc:cmb:gdocs:products:taxonomies:countries:Qatar:EN'
]);

export const RESIDENT_ONLY_ACCOUNT_EDIT_TYPES = [
  'add-account-to-case',
  'capture-product-account-basic-details'
];



// WEBPACK FOOTER //
// ./src/constants.js